"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepositories = exports.useReindex = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../../composite/snackbar/snackbar-types");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const error_utils_1 = require("../../../utils/error-utils");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const admin_context_1 = require("../../../providers/admin/admin-context");
/**
 *  POST request to reindex given stores.
 */
function reindexCall(url, names) {
    return (0, abortable_fetch_1.abortableFetch)(url, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'POST',
        body: JSON.stringify(names),
    });
}
const useReindex = () => {
    const intl = (0, react_intl_1.useIntl)();
    const { reindexUrl } = (0, react_1.useContext)(admin_context_1.AdminContext);
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const reindex = (0, event_callback_hook_1.useEventCallback)(async (repositories) => {
        const names = repositories
            .filter((repository) => repository.active)
            .map((r) => r.name);
        try {
            setLoading(true);
            await reindexCall(reindexUrl, names).none();
            const message = intl.formatMessage({
                id: 'EAS_DEVTOOLS_REINDEX_MSG_SUCCESS',
                defaultMessage: 'Reindexace dokončena',
            });
            showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_DEVTOOLS_REINDEX_MSG_ERROR',
                    defaultMessage: 'Chyba reindexace: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    return {
        loading,
        reindex,
    };
};
exports.useReindex = useReindex;
/**
 * GET request to get all stores.
 */
function getRepositories(url) {
    return (0, abortable_fetch_1.abortableFetch)(url, {
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        method: 'GET',
    });
}
const useRepositories = () => {
    const { reindexUrl } = (0, react_1.useContext)(admin_context_1.AdminContext);
    const [repositories, setRepositories] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        getRepositories(reindexUrl)
            .json()
            .then((repositiories) => {
            setRepositories(repositiories.map((repository) => ({
                name: repository,
                active: false,
            })));
        });
    }, [reindexUrl]);
    return [repositories, setRepositories];
};
exports.useRepositories = useRepositories;
//# sourceMappingURL=admin-reindex-hooks.js.map